(function () {
  var MONTH_SHORT = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  var MONTH_FULL = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  var DAY_NAMES = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  // Abbreviated weekday names. Every day_name* format used DAY_NAMES, so a short
  // weekday ('Mon, Aug 10') was not reachable from any format option.
  var DAY_SHORT = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

  function boolAttr(value) {
    return value === 'true';
  }

  function toArray(nodeList) {
    return Array.prototype.slice.call(nodeList || []);
  }

  function ordinal(n) {
    var suffixes = ['th', 'st', 'nd', 'rd'];
    var v = n % 100;
    return n + (suffixes[(v - 20) % 10] || suffixes[v] || suffixes[0]);
  }

  function getTimezoneCity() {
    try {
      var timezone = Intl.DateTimeFormat().resolvedOptions().timeZone || '';
      if (!timezone || timezone.indexOf('/') === -1) return '';
      return timezone.split('/').pop().replace(/_/g, ' ');
    } catch (e) {
      return '';
    }
  }

  function buildLocationText(data, type) {
    var city = data.city || '';
    var region = data.region || '';
    var country = data.country || '';

    if (type === 'region') return region;
    if (type === 'country') return country;
    if (type === 'city_region') return city && region ? city + ', ' + region : city || region;
    if (type === 'city_country') return city && country ? city + ', ' + country : city || country;
    return city;
  }

  function applyGeo(spans, geo) {
    spans.forEach(function (span) {
      var type = span.dataset.locationType || 'city';
      var fallback = span.dataset.locationFallback || 'your area';
      var text = buildLocationText(geo, type);
      span.textContent = text || fallback;
    });
  }

  function initLocation(block) {
    var spans = toArray(block.querySelectorAll('.text-block__location'));
    if (!spans.length) return;

    var needsInit = false;
    spans.forEach(function (span) {
      if (span.dataset.textLocationInitialized !== 'true') needsInit = true;
      span.dataset.textLocationInitialized = 'true';
    });
    if (!needsInit) return;

    var cacheKey = 'sugar_geo_v4';
    var cached = null;
    try { cached = sessionStorage.getItem(cacheKey); } catch (e) {}

    if (cached) {
      try {
        applyGeo(spans, JSON.parse(cached));
        return;
      } catch (e) {}
    }

    var firstSpan = spans[0];

    fetch('https://ipwho.is/')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (!data || data.success === false) throw new Error();
        return { city: data.city || '', region: data.region || '', country: data.country || '' };
      })
      .catch(function () {
        return {
          city: getTimezoneCity(),
          region: '',
          country: (firstSpan && (firstSpan.dataset.locationCountry || firstSpan.dataset.locationCountryCode)) || '',
        };
      })
      .then(function (geo) {
        try { sessionStorage.setItem(cacheKey, JSON.stringify(geo)); } catch (e) {}
        applyGeo(spans, geo);
      });
  }

  function initDates(block) {
    var spans = toArray(block.querySelectorAll('.text-block__date'));
    if (!spans.length) return;

    spans.forEach(function (span) {
      if (span.dataset.textDateInitialized === 'true') return;
      span.dataset.textDateInitialized = 'true';

      var offset = parseInt(span.dataset.dateOffset, 10) || 0;
      var direction = span.dataset.dateDirection === 'future' ? 1 : -1;
      var format = span.dataset.dateFormat || 'short';
      var date = new Date();
      /* data-date-timezone="store" (Reviews / DB - Featured review): count from
         the store's calendar day, not the visitor's. data-date-utc-offset is the
         shop's "+hhmm" offset, printed by snippets/review-date-token.liquid. */
      var utcOffset = span.dataset.dateUtcOffset || '';
      if (span.dataset.dateTimezone === 'store' && /^[+-]\d{4}$/.test(utcOffset)) {
        var offsetMinutes = (utcOffset.charAt(0) === '-' ? -1 : 1) *
          (parseInt(utcOffset.substr(1, 2), 10) * 60 + parseInt(utcOffset.substr(3, 2), 10));
        var storeNow = new Date(Date.now() + offsetMinutes * 60000);
        date = new Date(storeNow.getUTCFullYear(), storeNow.getUTCMonth(), storeNow.getUTCDate());
      }
      date.setDate(date.getDate() + offset * direction);

      var d = date.getDate();
      var m = date.getMonth();
      var y = date.getFullYear();
      var pad = function (n) { return n < 10 ? '0' + n : '' + n; };
      var text;

      switch (format) {
        case 'long':
          text = MONTH_FULL[m] + ' ' + d + ', ' + y; break;
        case 'day_name':
          text = DAY_NAMES[date.getDay()] + ', ' + MONTH_SHORT[m] + ' ' + d; break;
        case 'day_name_short':
          text = DAY_SHORT[date.getDay()] + ', ' + MONTH_SHORT[m] + ' ' + d; break;
        case 'day_name_long':
          text = DAY_NAMES[date.getDay()] + ', ' + MONTH_FULL[m] + ' ' + d; break;
        case 'numeric':
          text = pad(m + 1) + '/' + pad(d) + '/' + y; break;
        case 'day_month':
          text = d + ' ' + MONTH_SHORT[m] + ' ' + y; break;
        case 'day_month_long':
          text = d + ' ' + MONTH_FULL[m] + ' ' + y; break;
        case 'month_day':
          text = MONTH_FULL[m] + ' ' + d; break;
        case 'long_ordinal':
          text = MONTH_FULL[m] + ' ' + ordinal(d) + ', ' + y; break;
        case 'day_name_long_ordinal':
          text = DAY_NAMES[date.getDay()] + ', ' + MONTH_FULL[m] + ' ' + ordinal(d); break;
        case 'day_month_long_ordinal':
          text = ordinal(d) + ' ' + MONTH_FULL[m] + ' ' + y; break;
        case 'month_day_ordinal':
          text = MONTH_FULL[m] + ' ' + ordinal(d); break;
        default:
          text = MONTH_SHORT[m] + ' ' + d + ', ' + y;
      }

      span.textContent = text;
    });
  }

  /* ---------- Countdown ----------

     The cutoff modes below are a port of the Delivery estimate block
     (snippets/cart-delivery-estimate.liquid) so a [countdown] token and a
     Delivery estimate line configured the same way line up: the same five
     modes, read from the same settings, computed the same way. The one
     deliberate difference is what a looping mode does after its first cycle —
     see countdownSecondsLeft below.

     Every tick derives the remaining time from absolute clock time rather than
     decrementing a counter, so a sleeping tab or a container re-render cannot
     drift the timer. */

  var DAY_MS = 24 * 60 * 60 * 1000;

  /* Current wall clock in an IANA zone, or the visitor's zone when tz is empty.
     hourCycle 'h23' keeps the hour 0-23 regardless of locale — en-US defaults
     to h12 and silently broke cutoff detection in the Delivery estimate. */
  function zonedClock(tz) {
    var opts = { hourCycle: 'h23', hour: '2-digit', minute: '2-digit', second: '2-digit' };
    if (tz) opts.timeZone = tz;
    var map = {};
    try {
      new Intl.DateTimeFormat('en-GB', opts).formatToParts(new Date()).forEach(function (part) {
        map[part.type] = part.value;
      });
    } catch (e) {
      var local = new Date();
      return { h: local.getHours(), m: local.getMinutes(), s: local.getSeconds() };
    }
    var h = parseInt(map.hour, 10);
    if (h === 24) h = 0;
    return { h: h, m: parseInt(map.minute, 10), s: parseInt(map.second, 10) || 0 };
  }

  function nextLocalMidnightAfter(ts) {
    var d = new Date(ts);
    d.setHours(24, 0, 0, 0);
    return d.getTime();
  }

  function nextTopOfHourAfter(ts) {
    var d = new Date(ts);
    d.setHours(d.getHours() + 1, 0, 0, 0);
    return d.getTime();
  }

  /* A wall-clock date/time in an IANA zone -> timestamp, by probing a nearby
     Date and reading it back through Intl. Same technique as the Delivery
     estimate's parseCustomEndTimestamp. */
  function wallClockToTs(y, mo, d, h, mi, tz) {
    if (!tz) return new Date(y, mo, d, h, mi, 0).getTime();
    var naiveUtc = Date.UTC(y, mo, d, h, mi, 0);
    var map = {};
    try {
      new Intl.DateTimeFormat('en-GB', {
        timeZone: tz,
        hourCycle: 'h23',
        year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', second: '2-digit',
      }).formatToParts(new Date(naiveUtc)).forEach(function (part) {
        map[part.type] = part.value;
      });
    } catch (e) {
      return new Date(y, mo, d, h, mi, 0).getTime();
    }
    var asTz = Date.UTC(
      parseInt(map.year, 10),
      parseInt(map.month, 10) - 1,
      parseInt(map.day, 10),
      parseInt(map.hour, 10),
      parseInt(map.minute, 10),
      parseInt(map.second, 10) || 0
    );
    return naiveUtc - (asTz - naiveUtc);
  }

  /* Seconds remaining, or null once the timer is expired for good.

     Each looping mode repeats on its OWN cycle: fixed_duration every N,
     ends_at_hour every hour on the hour, ends_at_midnight every midnight,
     fixed_cutoff daily at the cutoff time. This is the one place the port
     deliberately parts company with the Delivery estimate, which switches to a
     flat 24h cycle after the first rollover. That rule exists there to keep a
     projected delivery DATE believable; a bare timer has no date, so applying
     it would turn a 5-minute countdown into a 24-hour one — visibly "not
     restarting", and meaningless with Show hours off. */
  function countdownSecondsLeft(cfg, nowTs) {
    if (cfg.mode === 'custom_end_date') {
      if (cfg.endTs == null || isNaN(cfg.endTs)) return 0;
      if (nowTs >= cfg.endTs) return null;
      return Math.floor((cfg.endTs - nowTs) / 1000);
    }

    if (cfg.mode === 'fixed_cutoff') {
      var clock = zonedClock(cfg.timezone);
      var left = (cfg.cutoffMinutes - (clock.h * 60 + clock.m)) * 60 - clock.s;
      if (left > 0) return left;
      /* Past today's cutoff: roll on to tomorrow's, or sit at zero. */
      return cfg.restart ? left + 86400 : 0;
    }

    if (cfg.mode === 'ends_at_hour' || cfg.mode === 'ends_at_midnight') {
      var nextTarget = cfg.mode === 'ends_at_hour' ? nextTopOfHourAfter : nextLocalMidnightAfter;
      if (!cfg.restart) {
        /* One shot: the target the visitor's first cycle was aimed at. */
        var firstTarget = nextTarget(cfg.anchorTs);
        if (nowTs >= firstTarget) return 0;
        return Math.floor((firstTarget - nowTs) / 1000);
      }
      return Math.max(0, Math.floor((nextTarget(nowTs) - nowTs) / 1000));
    }

    /* fixed_duration */
    if (cfg.durationSeconds < 1) return 0;
    var elapsed = Math.floor((nowTs - cfg.anchorTs) / 1000);
    if (elapsed < 0) elapsed = 0;
    if (!cfg.restart) return Math.max(0, cfg.durationSeconds - elapsed);
    /* Cycles through durationSeconds..1 and straight back to the top, so a
       looping timer never sits on a dead 00:00. */
    return cfg.durationSeconds - (elapsed % cfg.durationSeconds);
  }

  function initCountdownEl(timer) {
    if (!timer || timer.dataset.textCountdownInitialized === 'true') return;
    timer.dataset.textCountdownInitialized = 'true';

    var hoursEl = timer.querySelector('[data-countdown-hours]');
    var minutesEl = timer.querySelector('[data-countdown-minutes]');
    var secondsEl = timer.querySelector('[data-countdown-seconds]');

    var initialHours = parseInt(timer.dataset.initialHours, 10) || 0;
    var initialMinutes = parseInt(timer.dataset.initialMinutes, 10) || 0;
    var initialSeconds = parseInt(timer.dataset.initialSeconds, 10) || 0;
    var cutoffParts = (timer.dataset.cutoffTime || '15:00').split(':');

    var cfg = {
      mode: timer.dataset.cutoffMode || 'fixed_duration',
      /* Only an explicit "nothing" stops the loop. Defaulting the other way
         means one nil in Liquid silently freezes a timer at 00:00, which is
         indistinguishable from a broken clock; defaulting to looping degrades
         into the far more visible "it keeps running". */
      restart: timer.dataset.restart !== 'nothing',
      timezone: timer.dataset.timezone || '',
      durationSeconds: initialHours * 3600 + initialMinutes * 60 + initialSeconds,
      cutoffMinutes: (parseInt(cutoffParts[0], 10) || 0) * 60 + (parseInt(cutoffParts[1], 10) || 0),
      anchorTs: new Date().getTime(),
      endTs: null,
    };

    if (cfg.mode === 'custom_end_date') {
      var dateMatch = (timer.dataset.endDate || '').match(/^(\d{4})-(\d{2})-(\d{2})$/);
      var timeMatch = (timer.dataset.endTime || '').match(/^(\d{1,2}):(\d{2})$/);
      if (dateMatch) {
        cfg.endTs = wallClockToTs(
          parseInt(dateMatch[1], 10),
          parseInt(dateMatch[2], 10) - 1,
          parseInt(dateMatch[3], 10),
          timeMatch ? parseInt(timeMatch[1], 10) : 23,
          timeMatch ? parseInt(timeMatch[2], 10) : 59,
          timer.dataset.endTimezoneMode === 'store' ? timer.dataset.endStoreTimezone || '' : ''
        );
      }
    }

    /* The anchor is when this visitor's first cycle started. fixed_duration
       always needs it; the hour/midnight modes need it only when set to stop
       rather than loop. Persisting it (opt-in, via
       data-countdown-persist) is what keeps a timer continuous when its
       container re-renders: the cart drawer throws away and rebuilds its whole
       subtree on every cart change, so without an anchor the timer would jump
       back to full whenever the shopper touched a quantity. */
    var persistKey = timer.dataset.countdownPersist;
    if (persistKey) {
      var storeKey = 'shine_countdown_v2_' + persistKey;
      var stored = NaN;
      try { stored = parseInt(sessionStorage.getItem(storeKey), 10); } catch (e) {}
      if (isNaN(stored) || stored > cfg.anchorTs) {
        try { sessionStorage.setItem(storeKey, String(cfg.anchorTs)); } catch (e) {}
      } else {
        cfg.anchorTs = stored;
      }
    }

    function paint() {
      var left = countdownSecondsLeft(cfg, new Date().getTime());
      if (left === null) {
        /* custom_end_date only: past its end datetime, matching the Delivery
           estimate, which hides itself rather than showing a dead 00:00:00. */
        timer.hidden = true;
        return false;
      }
      if (hoursEl) hoursEl.textContent = String(Math.floor(left / 3600)).padStart(2, '0');
      if (minutesEl) minutesEl.textContent = String(Math.floor((left % 3600) / 60)).padStart(2, '0');
      if (secondsEl) secondsEl.textContent = String(left % 60).padStart(2, '0');
      return true;
    }

    if (!paint()) return;
    /* Stop once the element is detached, so repeated container re-renders don't
       leave a pile of intervals writing into orphaned DOM. */
    var intervalId = setInterval(function () {
      if (timer.isConnected === false || !paint()) clearInterval(intervalId);
    }, 1000);
  }

  function initCountdown(block) {
    initCountdownEl(block.querySelector('[data-countdown-timer]'));
  }

  /* Everything the timer needs to know about its own configuration, so a
     persist key changes the moment the merchant changes a setting and the new
     cycle starts fresh instead of resuming the old one's anchor. */
  function countdownFingerprint(timer) {
    return [
      timer.dataset.cutoffMode, timer.dataset.restart,
      timer.dataset.initialHours, timer.dataset.initialMinutes,
      timer.dataset.initialSeconds, timer.dataset.cutoffTime,
      timer.dataset.endDate, timer.dataset.endTime,
    ].join('-');
  }

  /* Clones an Inline Countdown's <template> into the [data-countdown-slot] a
     parent block left for it.

     The child block ships its own inline script that does this, but an inline
     script only runs while the document is being parsed — the cart drawer
     re-renders by replacing markup, which never re-executes it, so after the
     first cart change the slot would come back empty and the countdown would
     vanish. Doing it here covers every re-render path, and is idempotent so
     the child's own script racing us is harmless. */
  function mountCountdownSlots(scope) {
    toArray(scope.querySelectorAll('[data-countdown-slot]')).forEach(function (slot) {
      if (!slot.querySelector('[data-countdown-timer]')) {
        var root = slot.closest ? slot.closest('.sw-block') : null;
        var template = root && root.querySelector('[data-countdown-tpl]');
        if (!template || !template.content) return;
        slot.appendChild(template.content.cloneNode(true));
      }

      /* Only the child knows its own settings, so the parent leaves the persist
         key on the slot and it is transferred here. Deliberately outside the
         mount branch above: on a first page load the child's own inline script
         has already mounted the timer by the time this runs, and the key still
         has to reach it. */
      var timer = slot.querySelector('[data-countdown-timer]');
      if (timer && slot.dataset.countdownPersist && !timer.dataset.countdownPersist) {
        timer.dataset.countdownPersist =
          slot.dataset.countdownPersist + '-' + countdownFingerprint(timer);
      }
    });
  }

  function findBodyModalByClass(className) {
    var children = document.body ? document.body.children : [];
    var i;
    for (i = 0; i < children.length; i++) {
      if (children[i].classList && children[i].classList.contains(className)) {
        return children[i];
      }
    }
    return null;
  }

  function getParsedInt(value, fallback) {
    var parsed = parseInt(value, 10);
    return isNaN(parsed) ? fallback : parsed;
  }

  function resolveSectionTargetId(config) {
    var sectionId = (config.sectionId || '').replace(/^#/, '');
    if (sectionId) return sectionId;
    if (config.href && config.href.charAt(0) === '#') return config.href.slice(1);
    return '';
  }

  function scrollToSectionTarget(config) {
    var targetId = resolveSectionTargetId(config);
    if (!targetId) return;

    var target = document.getElementById(targetId);
    if (!target) return;

    var scrollOffset = getParsedInt(config.scrollOffset, 20);
    var headerHeight = getParsedInt(
      getComputedStyle(document.documentElement).getPropertyValue('--header-height') || '0',
      0
    );
    var targetPosition = target.getBoundingClientRect().top + window.scrollY - headerHeight - scrollOffset;

    var stickyHeader = document.querySelector('sticky-header');
    if (stickyHeader) {
      stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }

    window.scrollTo({
      top: targetPosition,
      behavior: 'smooth',
    });
  }

  function navigateToPage(config) {
    var href = config.href || '';
    if (!href || href === '#') return;

    if (config.newTab) {
      window.open(href, '_blank', 'noopener,noreferrer');
      return;
    }

    window.location.href = href;
  }

  function initLinkActions(block) {
    var contentArea = block.querySelector('.text-block__content');
    if (!contentArea) return;

    var configs = [
      {
        enabled: boolAttr(block.dataset.textLinkStrongEnabled),
        selector: 'strong',
        mode: block.dataset.textLinkStrongMode || 'page',
        href: block.dataset.textLinkStrongHref || '',
        newTab: boolAttr(block.dataset.textLinkStrongNewTab),
        sectionId: block.dataset.textLinkStrongSectionId || '',
        scrollOffset: block.dataset.textLinkStrongScrollOffset,
      },
      {
        enabled: boolAttr(block.dataset.textLinkEmEnabled),
        selector: 'em',
        mode: block.dataset.textLinkEmMode || 'page',
        href: block.dataset.textLinkEmHref || '',
        newTab: boolAttr(block.dataset.textLinkEmNewTab),
        sectionId: block.dataset.textLinkEmSectionId || '',
        scrollOffset: block.dataset.textLinkEmScrollOffset,
      },
      {
        enabled: boolAttr(block.dataset.textLinkUnderlineEnabled),
        selector: 'u, span[style*="underline"]',
        mode: block.dataset.textLinkUnderlineMode || 'page',
        href: block.dataset.textLinkUnderlineHref || '',
        newTab: boolAttr(block.dataset.textLinkUnderlineNewTab),
        sectionId: block.dataset.textLinkUnderlineSectionId || '',
        scrollOffset: block.dataset.textLinkUnderlineScrollOffset,
      },
    ];

    configs.forEach(function (config) {
      if (!config.enabled) return;

      toArray(contentArea.querySelectorAll(config.selector)).forEach(function (trigger) {
        if (trigger.dataset.textLinkInitialized === 'true') return;
        if (trigger.closest('a')) return;

        trigger.dataset.textLinkInitialized = 'true';

        if (!trigger.hasAttribute('role')) trigger.setAttribute('role', 'link');
        if (!trigger.hasAttribute('tabindex')) trigger.setAttribute('tabindex', '0');
        if (!trigger.hasAttribute('aria-label')) {
          var label = (trigger.textContent || '').trim();
          if (label) trigger.setAttribute('aria-label', label);
        }

        function activate(event) {
          event.preventDefault();
          event.stopPropagation();

          if (config.mode === 'section') {
            scrollToSectionTarget(config);
            return;
          }

          navigateToPage(config);
        }

        trigger.addEventListener('click', activate);
        trigger.addEventListener('keydown', function (event) {
          if (event.key === 'Enter' || event.key === ' ' || event.key === 'Spacebar') {
            activate(event);
          }
        });
      });
    });
  }

  function initPopup(block, blockId) {
    var modalId = block.dataset.textPopupModalId || blockId;
    var uniqueClass = 'text-popup-modal--' + modalId;
    var sectionRoot = block.closest('.shopify-section') || document;
    var modal = sectionRoot.querySelector('.' + uniqueClass) || document.querySelector('.' + uniqueClass);
    var contentArea = block.querySelector('.text-block__content');
    if (!modal || !contentArea) return;

    var existingBodyModal = findBodyModalByClass(uniqueClass);
    if (existingBodyModal && existingBodyModal !== modal) {
      if (existingBodyModal.classList.contains('is-open')) {
        document.body.style.overflow = '';
      }
      existingBodyModal.remove();
    }

    if (modal.parentNode !== document.body) {
      document.body.appendChild(modal);
    }

    if (modal.dataset.textPopupInitialized === 'true') return;
    modal.dataset.textPopupInitialized = 'true';

    var closeOnOutsideClick = boolAttr(block.dataset.textPopupCloseOnOutside);
    var testMode = block.dataset.textPopupTestMode || modal.dataset.testMode || 'off';
    var triggerSelectors = [];

    if (boolAttr(block.dataset.textPopupStrong)) triggerSelectors.push('strong');
    if (boolAttr(block.dataset.textPopupEm)) triggerSelectors.push('em');
    if (boolAttr(block.dataset.textPopupUnderline)) {
      triggerSelectors.push('u');
      triggerSelectors.push('span[style*="underline"]');
    }

    if (!triggerSelectors.length) return;

    function openModal() {
      modal.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }

    function closeModal() {
      if (testMode !== 'off') return;
      modal.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    function handleEscape(event) {
      if (event.key === 'Escape' && modal.classList.contains('is-open')) {
        closeModal();
      }
    }

    if (testMode === 'animate') {
      var speed = parseInt(modal.dataset.animationSpeed) || 250;
      document.body.style.overflow = 'hidden';
      (function animateLoop() {
        modal.classList.add('is-open');
        setTimeout(function () {
          modal.classList.remove('is-open');
          setTimeout(animateLoop, speed + 400);
        }, 2000);
      })();
    }

    triggerSelectors.forEach(function (selector) {
      toArray(contentArea.querySelectorAll(selector)).forEach(function (trigger) {
        trigger.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          openModal();
        });
      });
    });

    modal.addEventListener('click', function (event) {
      if (event.target === modal && closeOnOutsideClick) {
        closeModal();
      }
    });

    toArray(modal.querySelectorAll('[data-text-popup-close]')).forEach(function (button) {
      button.addEventListener('click', closeModal);
    });

    document.addEventListener('keydown', handleEscape);
  }

  function initBlock(block) {
    if (!block || block.dataset.textBlockInitialized === 'true') return;
    block.dataset.textBlockInitialized = 'true';

    var blockId = block.dataset.textBlockId;
    if (!blockId) return;

    if (boolAttr(block.dataset.textPopupEnabled)) {
      initPopup(block, blockId);
    }
    initLinkActions(block);
    if (boolAttr(block.dataset.textCountdownEnabled)) {
      initCountdown(block);
    }
    if (boolAttr(block.dataset.textLocationEnabled)) {
      initLocation(block);
    }
    if (boolAttr(block.dataset.textDateEnabled)) {
      initDates(block);
    }
  }

  function initAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    /* Slots first — the timers they mount are what the next step initialises. */
    mountCountdownSlots(scope);
    if (scope.matches && scope.matches('[data-text-block]')) {
      initBlock(scope);
    }

    toArray(scope.querySelectorAll('[data-text-block]')).forEach(initBlock);
    /* Countdown markup ticks whenever it is present. It used to start only via
       a parent block's data-text-countdown-enabled flag, which left the timer
       dead if the parent rendered the markup without the flag. */
    toArray(scope.querySelectorAll('[data-countdown-timer]')).forEach(initCountdownEl);
  }

  function onReady() {
    initAll(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady, { once: true });
  } else {
    onReady();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:block:select', function (event) {
    initAll(event.target);
  });

  /* AJAX cart updates replace the drawer's markup wholesale and this theme
     dispatches no cart re-render event (see the note in
     assets/cart-goal-confetti.js), so token markup inside the drawer would
     arrive back uninitialised: a frozen countdown and [location] stuck on its
     fallback. Watching the <cart-drawer> subtree catches every re-render path
     regardless of which code did the replacing. initBlock() is idempotent, so
     re-scanning costs nothing when nothing token-shaped came back. */
  var observedDrawers = typeof WeakSet === 'function' ? new WeakSet() : null;

  function watchCartDrawers() {
    if (!observedDrawers || typeof MutationObserver !== 'function') return;
    toArray(document.querySelectorAll('cart-drawer')).forEach(function (drawer) {
      if (observedDrawers.has(drawer)) return;
      observedDrawers.add(drawer);
      var pending = false;
      new MutationObserver(function () {
        if (pending) return;
        pending = true;
        requestAnimationFrame(function () {
          pending = false;
          initAll(drawer);
        });
      }).observe(drawer, { childList: true, subtree: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchCartDrawers, { once: true });
  } else {
    watchCartDrawers();
  }

  /* Section reloads replace the <cart-drawer> element itself, so re-attach. */
  document.addEventListener('shopify:section:load', watchCartDrawers);
})();
